<template>
    <div class="home-page">
		<Header></Header>
		<div class="mt100 ac" v-if="notFound">
			<p class="fs40">{{$t('No_Question')}}!</p>
			<button class="button active fs40 mt100" style="width: 280px;margin: 50px auto;line-height: 80px;border-radius: 2px;" @click="back">{{$t('Back')}}</button>
		</div>
		<div class="content" v-if="list!=''">
      	<div class="nav flex">
      		<div class="back" @click="back">
      			<img src="static/images/return.png" />
      		</div>
      		<span class="">{{$t('Question_List')}}</span>
      	</div>
        <div class="answers-img">
          <img class="flex" :src="list[num].image" />
        </div>
			<div class="list">
				<div class="answers-list">
					<div class="answers-content ac clearfix">
            <div class="ans-title fs33">{{num+1}}.{{list[num].title}}</div>
            <div class="miao fs33 ">
              <span class="">{{times}}s</span>
            </div>
					</div>
          <ul class="ul flex fs33 mt30">
          	<li class="font-c flex-between" :class="{'active':isActive==index}" @click="goNext(list[num].id,index,1)" v-for="(item,index) in list[num].options.split('|')">
            <span>{{item}}</span>
            </li>
          </ul>
				</div>
			</div>
		</div>
		<Dialog ref="saveDialog" title="" type="alert" :modalFoot="modalFoot" :cancelText="$t('No')">
            <div slot="mdBox" >
                <div class="ac fs33" v-if="result!=''">
					<img src="static/images/success.png" />
					<div class="tan1">
						<div class="t1">{{$t('Your_correct_answer_number_is')}}</div>
						<div class="fs50">{{result.number}}/{{result.all_number}}</div>
					</div>
					<div class="tan1">
						<div class="t1">{{$t('Your_total_score_is')}}</div>
						<div class="fs80 crff1d4f">{{result.score}}</div>
					</div>
					<div class="modal-footer ac">
						<button class="btn btn-blue" @click="review">{{$t('Review')}}</button>
						<button class="btn btn-none" id="closeModal" @click="confirm">{{$t('Confirm')}}</button>
					</div>
				</div>
            </div>
        </Dialog>
	</div>
</template>
<script>
import Header from '../components/header'
import Dialog from '../components/dialog'
export default {
    components:{
		Header,
		Dialog
    },
    data() {
        return {
			notFound:false,
			list:[],
			option:['A','B',"C","D"],
			num:0,
			isActive:-1,
			times: 30,
			question_id:'',
			msg:'',
			result:{},
			modalFoot:false
		}
    },
	destroyed() {
		clearInterval(this.timer)
	},
    mounted() {
		let that = this;
    },
	created(){
		let that = this
		clearInterval(that.timer)
		this.getHome();
		this.getTimes();
	},
    methods: {
		back(){
			this.$router.go(-1);
		},
		// 弹框保存
		saveModal (){
			let that =this;
			//that.$parent.loadModal(true);
			let data = {'apikey':'DaXwcg9vFV4J9tWsRzCv4UZUY8KrHjEm',mobile:localStorage.getItem('mobile')}
			let url = 'https://truefalse.api.vidamm.com/buy?mobile='+localStorage.getItem('mobile')
			//window.open(url);
			window.location.href = url
			/*
			that.$api.post('/api/buy',data,r =>{
				that.$parent.returnCode(r,function(){
					that.$utils.alertText(r.msg,80);
					that.$router.push({path:'/list'})
					that.$parent.loadModal(false);
                });

			})*/

		},
		review(){
			let that = this
			that.$refs.saveDialog.closeMask();
			that.$router.push({path:'/answeredList',query: {id:that.question_id}})
		},
		confirm(){
			let that = this
			that.$refs.saveDialog.closeMask();
			that.$router.push({path:'/list'})
		},
		getTimes(){
			let that = this;
			that.times =15
			clearInterval(that.timer)
			that.timer = setInterval(()=>{
				that.times--
				//console.log(that.times);
				if(that.times===0){
				  clearInterval(that.timer)
				  let type=1;
				  if(that.num+1==that.list.length){
					type=2
				  }
				  that.goNext(that.list[that.num].id,type);
				}
			},1000)
		},
		//下一题
		goNext(id,index,type){
			let that = this;
      that.isActive = index
      clearInterval(that.timer)
      that.timer = setInterval(()=>{
        if(that.num+1==that.list.length){
          that.getProcess(id,2);
        }else{
          that.num++
          clearInterval(that.timer)
          that.getProcess(id,type);
          that.isActive = -1
          that.getTimes();
        }
      },1500)
			if(that.isActive!=-1){

			}else{
				//that.$utils.alertText('Please choose an answer',80);
			}
		},
		getProcess(id,type){
			let that =this;
			//that.$parent.loadModal(true);
			let data = {'token':localStorage.getItem('token'),uuid:localStorage.getItem('uuid'),'id':id,'solution':that.option[that.isActive]}
			let url = '/core/process';
			that.$api.post(url,data,r =>{
				if(type==2){
					that.$nextTick(function () {
						that.getSubmit(id);
					})
					//console.log(type);
				}
				that.$parent.returnCode(r,function(){
					//that.$utils.alertText(r.data.msg,80,1500);
					that.$parent.loadModal(false);
					//that.getHome();
                });
			})
		},
		getSubmit(id){
			let that =this;
			//that.$parent.loadModal(true);
			let url = '/core/result';
			let	data ={'token':localStorage.getItem('token'),uuid:localStorage.getItem('uuid'),'question_id':that.question_id,'solution':that.option[that.isActive]}
			that.$api.post(url,data,r =>{
				if(r.code==30001){
					that.$router.push({path:'/list'})
				}
				that.$parent.returnCode(r,function(){
					that.result = r.data
					//console.log(that.result)
					that.$refs.saveDialog.showMaskFun();
					clearInterval(that.timer)
					that.$parent.loadModal(false);
      });

			})
		},
		getOption(index){
			let that = this;
			that.isActive = index
		},
		getHome(){
			let that =this;
			//that.$parent.loadModal(true);
			let data = {'token':localStorage.getItem('token'),uuid:localStorage.getItem('uuid'),'id':that.$route.query.id}
			that.$api.post('/core/star',data,r =>{
				if(r.code==30001||r.code==30002){
					that.msg = r.msg
					that.notFound = true;
					clearInterval(that.timer)
				}
				that.$parent.returnCode(r,function(){
					that.list = r.data.list
					that.question_id = r.data.question_id
					that.notFound = false
					that.$parent.loadModal(false);
                });

			})
		}
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/answer.vue